module.exports = __webpack_public_path__ + "img/slide1-2.017281d9.png";